import { ThunkResult } from "..";
import { apiGet } from "../../utils/api";
import * as actions from "./actions";
import { IRegion } from "./types";

export const fetchRegions =
  (): ThunkResult<Promise<void>> => async (dispatch, getState) => {
    const { byId } = getState().regions;

    // Cache: if we already have regions, don't refetch
    if (Object.keys(byId).length > 0) {
      return;
    }

    try {
      await apiGet<IRegion[]>("regions/", dispatch, actions.addRegions);
    } catch (e) {
      return;
    }
  };
